import axios from "axios";

const processedCompanies = (params, config) => {
  return axios.get(`/api/v1/processed_companies`, {
    params,
    ...config,
  });
};

const startLearning = (company_id) => {
  return axios.post(`/api/v1/processed_companies/${company_id}/relearn`);
};

const checkRelearnQueue = () => {
  return axios.get(`/api/v1/processed_companies/check_relearn_queue`);
};

const setStartDate = (company_id, date) => {
  return axios.post(
    `/api/v1/processed_companies/${company_id}/set_start_date`,
    { start_date: date },
  );
};

const ApiAdminTools = {
  processedCompanies,
  startLearning,
  checkRelearnQueue,
  setStartDate,
};

export default ApiAdminTools;
